<template>
  <div style="display: none"></div>
</template>

<script setup>
import useDynamicBackground from "@/composables/useDynamicBackground";
useDynamicBackground();
</script>
